import Navbar from "@/layout/Navbar.vue";
import Sidebar from "@/layout/Sidebar.vue";

const medicalWasteRoutes = [
    {
        path: "/medical-waste-report",
        name: "MedicalWasteReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "MedicalWasteReports" */ "@/views/SubSystems/MedicalWasteReport.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },
]

export default medicalWasteRoutes